/**
 * Branding defaults -- frontend mirror of api/src/config/brandingDefaults.ts.
 *
 * Single source of truth for the Opus default brand values on the client side.
 * Used as fallback in useBrandingStore, BrandingProvider, and the FOUC script.
 */

export interface BrandingPublicShape {
  platform_name: string;
  logo_url: string | null;
  primary_color: string;
  secondary_color: string;
  default_theme: 'light' | 'dark' | 'system';
}

export const BRANDING_DEFAULTS: BrandingPublicShape = {
  platform_name: 'opus-ia',
  logo_url: '/opus-logo-branco.png',
  primary_color: '#00bbdd',
  secondary_color: '#8b5cf6',
  default_theme: 'dark',
};
